/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleAUpIcon64Regular = forwardRef('ArrowShapeTriangleAUpIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.327 51c-4.352 0-6.98-4.813-4.627-8.474l19.674-30.603c2.165-3.367 7.088-3.367 9.253 0L56.3 42.526c2.353 3.66-.275 8.474-4.627 8.474H12.328Zm-2.103-6.852C9.154 45.813 10.349 48 12.327 48h39.346c1.978 0 3.173-2.188 2.103-3.852L34.103 13.546c-.984-1.531-3.222-1.531-4.206 0L10.224 44.148Z" })));
});
